<template>
  <div class="container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <span class="leftLine"></span>
      <el-breadcrumb-item>用户列表 / 添加用户</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="padding:20px;background:rgb(249,249,249)">
      <div class="containerBox">
        <p class="header">添加用户</p>
        <div class="form">
          <el-form ref="form"
                   :model="form"
                   label-width="140px">
            <el-form-item label="账号"
                          prop="username"
                          :rules="[
      { required: true, message: '不能为空'}
    ]">
              <el-input v-model="form.username"></el-input>
            </el-form-item>
            <el-form-item label="联系方式"
                          prop="phone"
                          :rules="[
      { required: true, message: '不能为空'}
    ]">
              <el-input v-model="form.phone"></el-input>
            </el-form-item>
            <el-form-item label="所属部门"
                          prop="deptId"
                          :rules="[
      { required: true, message: '不能为空'}
    ]">
              <el-select v-model="form.deptId"
                         @change="getParentName"
                         placeholder="请选择">
                <el-option v-for="item in deptlist"
                           :key="item.value"
                           :label="item.name"
                           :value="item.deptId">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="是否代理"
                          prop="agent"
                          :rules="[
                              { required: true, message: '不能为空'}
                            ]">
              <el-select v-model="form.agent"
                         placeholder="请选择">
                <el-option label="否"
                           :value="0"></el-option>
                <el-option label="是"
                           :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否管理"
                          prop="agent"
                          :rules="[
                              { required: true, message: '不能为空'}
                            ]">
              <el-select v-model="form.userLevel"
                         placeholder="请选择">
                <el-option label="否"
                           :value="1"></el-option>
                <el-option label="是"
                           :value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="角色"
                          prop="roleIds"
                          :rules="[
      { required: true, message: '不能为空',trigger: 'change'}
    ]">
              <el-select v-model="form.roleIds"
                         multiple
                         placeholder="请选择">
                <el-option v-for="item in rolelist"
                           :key="item.value"
                           :label="item.roleName"
                           :value="item.roleId">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="登录密码"
                prop="password"
                :rules="[
                  { required: true, message: '不能为空',trigger: 'blur'},
                  { min: 7, message: '密码长度至少为7位', trigger: 'blur' },
                        {  validator: validatePass1, trigger: 'blur'}
                ]">
                
              <el-input v-model="form.password" placeholder="请输入7位及以上登陆密码" minlength="7"></el-input>
            </el-form-item>
            <el-form-item label="确认密码"
              prop="password1"
             
              :rules="[
                {  validator: validatePass2, trigger: 'blur'}
              ]">
              <el-input v-model="form.password1" placeholder="请再次输入登陆密码"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary"
                         @click="$router.back()">取消</el-button>
              <el-button style="margin-left:60px"
                         @click="submitForm('form')">提交</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { postuser, getuserOne, postrolelist, postdeptlist, putuser } from '../../API'
import { Encrypt } from '../../util/secret.js'
export default {
  data () {
    return {
      form: {
        password: '',
        password1: '',
        roleIds: []
      },
      validatePass1: (rule, value, callback) => {
        if (this.isSimplePwd(value) < 3) {
          callback(new Error('必须包含数字、小写字母、大写字母'));
        }
        else {
          callback();
        }
      },
      validatePass2: (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.form.password) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      },
      rolelist: [],
      deptlist: [],
      deptname: ''
    }
  },
  created () {
    if (localStorage.getItem('userIdbj')) {
      getuserOne(localStorage.getItem('userIdbj')).then(res => {
        if (res.code === 0) {
          this.form = res.data
          this.form.user = res.data.username
          this.form.password1 = res.data.password
          this.form.roleIds = []
          res.data.roleList.map((item, index, arr) => {
            this.form.roleIds.push(item.roleId)
          });
        }
      })
    }

    postrolelist().then(res => {
      if (res.code === 0) {
        this.rolelist = res.data
      }
    })
    postdeptlist().then(res => {
      if (res.code === 0) {
        this.deptlist = res.data
      }
    })
  },
  methods: {
    isSimplePwd (s) {
      if (s.length < 6) {
        return 0;
      }
      var ls = 0;
      if (s.match(/([a-z])+/)) {
        ls++;
      }
      if (s.match(/([0-9])+/)) {
        ls++;
      }
      if (s.match(/([A-Z])+/)) {
        ls++;
      }
      if (s.match(/[^a-zA-Z0-9]+/)) {
        ls++;
      }
      return ls;
    },
    getParentName (value) {
      let obj = this.deptlist.find((item) => {//这里的oneData就是上面遍历的数据源
        return item.deptId === value;//筛选出匹配数据
      });
      this.deptname = obj.name
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.form.userId) {
            let params = {
              deptId: this.form.deptId,
              deptName: this.deptname,
              lockFlag: this.form.lockFlag,
              password: Encrypt(this.form.password),
              phone: this.form.phone,
              agent: this.form.agent,
              userLevel: this.form.userLevel,
              roleIds: this.form.roleIds.join(','),
              username: this.form.username,
              userId: this.form.userId
            }
            putuser(params).then(res => {
              if (res.code === 0) {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                });
              }
            })
          }
          else {
            let params = {
              deptId: this.form.deptId,
              deptName: this.deptname,
              lockFlag: '0',
              password: Encrypt(this.form.password),
              phone: this.form.phone,
              agent: this.form.agent,
              userLevel: this.form.userLevel,
              roleIds: this.form.roleIds.join(','),
              username: this.form.username,
            }

            postuser(params).then(res => {
              if (res.code === 0) {
                this.$message({
                  message: '添加成功',
                  type: 'success'
                });
                let that = this
                setTimeout(
                  function () {
                    that.$router.back()
                  }, 1000
                )
              }
            })
          }

        } else {
          return false;
        }
      });
    },
  }
}
</script>
<style lang='less' scoped>
.header {
  height: 50px;
  line-height: 50px;
  background: rgb(243, 243, 243);
  padding: 0 20px;
  border: 1px solid rgba(228, 228, 228, 1);
}
.title {
  font-weight: 650;
  font-style: normal;
  font-size: 24px;
  color: #3498db;
}
/deep/ .el-breadcrumb__item {
  float: none;
}
.container {
  border: none;
  background-color: rgba(236, 240, 245, 1);
  padding: 0 0;
}
.leftLine {
  border-left: 5px solid rgba(52, 152, 219, 1);
  padding-right: 10px;
}
.form {
  background-color: #fff;
  border: 1px solid rgba(228, 228, 228, 1);
  padding: 20px;
}
.el-form {
  width: 400px;
  margin: auto;
}
.el-breadcrumb {
  height: 50px;
  font-size: 16px;
  line-height: 50px;
  color: #999;
  background-color: rgba(236, 240, 245, 1);
  margin-left: 20px;
}
.header {
  font-weight: 700;
  font-style: normal;
  color: #5e5e5e;
}
.ax_default {
  font-family: "ArialMT", "Arial";
  font-weight: 400;
  font-style: normal;
  font-size: 13px;
  border-bottom: 1px solid#333333;
  text-align: center;
  line-height: normal;
}
.line {
  height: 1px;
}
.pagination {
  float: right;
  /deep/ .el-pagination.is-background .btn-prev:disabled {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-prev {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-next:disabled {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-next {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .el-pager li {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #409eff;
  }
}
</style>
